import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { dateHoverRange } from "../../../utils/Helper";

export const useApproveTimesheet = (props) => {

    const gridRef = useRef(null);
    const row = useRef([]);
    const { showSuccess, showInfo } = useContext(ToastContext);
    const [loader, setLoader] = useState({ loader: false, loaderButton: false, loaderButtonAll: false });
    const [reject, setReject] = useState({ visible: false, remark: "", data: {} });
    const [filterValues, setFilterValues] = useState({ date: props?.hover, users: [], status: "send_for_approval", isChange: false });

    const columnDefs = useMemo(() => [
        {
            field: "checkbox",
            headerName: "",
            headerComponent: () => <div className="w100"><input type="checkbox" onChange={(e) => handleSelectAll(e)} /></div>,
            flex: 0.05,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => <div><input type="checkbox" checked={params?.data?.is_checked} onChange={(e) => handleSelectAll(e, params)} /></div>
        },
        {
            field: "user_display_name",
            headerName: "User",
            flex: 0.2,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "startdate",
            headerName: "Date",
            flex: 0.2,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => <div>{params?.value}</div>
        },
        {
            field: "comment",
            headerName: "Comment",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => <div title={params?.data?.comment}>{params?.data?.comment}</div>
        },
        {
            field: "logged_work_hours",
            headerName: "Log Hours",
            flex: 0.15,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "action",
            headerName: "Action",
            flex: 0.3,
            cellRenderer: (params) => {
                return (
                    <div className="d-flex justify-content-evenly">
                        {
                            filterValues?.status === "send_for_approval" && <div className="d-flex justify-content-center align-items-center">
                                <input type="radio" name="action-btn" id="action-approve" onChange={() => handleRejectPopup("radio", false, false, params?.data)} />
                                <label htmlFor="action-approve" style={{ cursor: "pointer" }}>Approve</label>
                            </div>
                        }

                        <div className="d-flex justify-content-center align-items-center">
                            <input type="radio" name="action-btn" id="action-reject" onChange={() => handleRejectPopup("radio", true, false, params?.data)} />
                            <label htmlFor="action-reject" style={{ cursor: "pointer" }}>Reject</label>
                        </div>
                    </div>
                )
            }
        },
    ], [filterValues?.status])

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        filterValues?.apiCall && getApproveTimesheet();
    }, [filterValues?.apiCall])

    const getApproveTimesheet = async () => {
        try {
            let start = "";
            let end = "";
            if ((filterValues?.date?.[0] && !filterValues?.date?.[1]) || (!filterValues?.date?.[0] && filterValues?.date?.[1])) {
                showInfo("Info", "Please select valid date range");
                return;
            } else if (filterValues?.date?.[0] && filterValues?.date?.[1]) {
                start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";;
                end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";;
            }
            setLoader((prev) => ({ ...prev, loader: true }));
            const payload = {
                "from_date": start || "",
                "to_date": end || "",
                "users": _.pluck(filterValues?.users, "user_code")?.toString() || "",
                "is_approved": filterValues?.status === "approved",
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSENTTIMESHEETAPPROVESUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.approve_timesheet_details;
                data?.map((item) => {
                    item["is_checked"] = false;
                })
                setRowData(data);
                row.current = data;
            }
        } catch (error) {
            console.error("error: ", error);
        } finally {
            setLoader((prev) => ({ ...prev, loader: false }));
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const handleSelectAll = (e, rowdata) => {
        const data = [...row.current]
        if (rowdata) {
            data[rowdata.node.rowIndex]["is_checked"] = e?.target?.checked;
            const rowNode = gridRef.current.api.getDisplayedRowAtIndex(rowdata.node.rowIndex);
            rowNode.setData(data[rowdata.node.rowIndex]);
            setRowData(data);
        } else {
            data.map((item) => item.is_checked = e.target.checked);
            setRowData(data);
        }

    }

    const handleRejectPopup = (key, isReject, rejected, data) => {
        if (key === "checkbox") {
            if (_.isEmpty(_.filter(rowData, { is_checked: true }))) {
                showInfo("Info", `Please select logs to ${isReject ? "reject" : "approve"}`);
                return;
            }
        }
        if (!isReject) {
            key === "checkbox" && setLoader((prev) => ({ ...prev, loaderButtonAll: true }));
            handleApproveReject(true, key, data);
        } else {
            if (rejected) {
                handleApproveReject(false, _.isEmpty(reject?.data) ? key : "radio", reject?.data);
            } else {
                setReject((prev) => ({ ...prev, visible: true, remark: "", data }));
            }
        }
    }

    const handleApproveReject = async (approve, key, data) => {
        try {
            if (reject?.remark?.length === 0 && !approve) {
                showInfo("info", "Please write a remark");
                setLoader((prev) => ({ ...prev, loaderButton: false }));
                return;
            }
            setLoader((prev) => ({ ...prev, loaderButton: true }));
            let ids = key === "radio" ? data?.timesheet_worklog_ids : _.pluck(_.filter(rowData, { is_checked: true }), "timesheet_worklog_ids")?.toString();
            const payload = {
                timesheet_worklog_ids: ids,
                is_approved: approve ? true : false,
                is_rejected: approve ? false : true,
                remark: reject?.remark
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSENTTIMESHEETAPPROVAL"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                getApproveTimesheet();
                if (!approve) {
                    setReject((prev) => ({ ...prev, visible: false }));
                }
                setReject((prev) => ({ ...prev, data: {} }));
                setLoader((prev) => ({ ...prev, loaderButton: false, loaderButtonAll: false }));
            }
        } catch (error) {
            console.error("error: ", error);
            setLoader((prev) => ({ ...prev, loaderButton: false, loaderButtonAll: false }));
        }
    }

    return useMemo(() => ({
        columnDefs, rowData, setRowData, getApproveTimesheet, loader, gridRef, handleRejectPopup, reject, setReject, filterValues, setFilterValues
    }), [columnDefs, rowData, getApproveTimesheet, loader, gridRef, handleRejectPopup, reject, setReject, filterValues, setFilterValues])
}